import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import axios from "axios";
import moment from "moment";
import * as echarts from "echarts";

/** 耗时日志仅当超过该毫秒数才输出（与 home / App 一致） */
const SLOW_STEP_LOG_MS = 500;
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      zoom: sessionStorage.getItem("zoom") || 1,
      ongoingStudentNum: 0,
      finishedStudentNum: 0,
      attendedHours: 0,
      attendedFee: 0,
      consumeInfoLoading: false,
      unattendedHours: 0,
      unattendedFee: 0,
      unattendInfoLoading: false,
      // 营收查询
      revenueSelect: "当月",
      revenueSelectedYear: "",
      revenueSelectedMonth: "",
      monthlyRevenue: [],
      dailyRevenue: [],
      yearRevenue: 0,
      monthRevenue: 0,
      previousYearRevenue: 0,
      previousMonthRevenue: 0,
      // 顾问
      consultantList: [],
      consultantNames: {},
      // 顾问业绩
      consultantPerformanceSelect: "全年",
      years: [],
      consultantPerformanceSelectedYear: "",
      consultantPerformanceSelectedMonth: "",
      // 时间范围
      consultantDateRange: [],
      selectAllTime: false,
      // 顾问业绩
      consultantPay: {},
      consultantRealPayTotal: {},
      consultantPayTotal: {},
      consultantRefund: {},
      consultantRefundTotal: {},
      consultantRefundServiceFeeTotal: {},
      consultantRefundRealTotal: {},
      consultantAttendFee: {},
      consultantUnattendFee: {},
      consultantAttendFeeSummary: {},
      consultantUnattendFeeSummary: {},
      consultantBalance: {},
      // 全部时间的业绩
      allTimePerformance: {},
      // 顾问业绩排名
      consultantPerformance: {},
      consultantPerformanceRank: {},
      // 顾问业绩排名
      consultantPerformanceRankArray: [],
      // 客户来源
      sourceSelect: "全年",
      sourceSelectedYear: "",
      sourceSelectedMonth: "",
      // 时间范围
      sourceDateRange: [],
      // 客户来源统计
      sourceStatistics: {},
      sourceStatisticsList: [],
      colorOptions: ["#ff6086", "#2651ff", "#fd9f02", "#09bd3c", "#007bff"],
      sourceColor: {}
    };
  },
  created() {
    this._div1LoadingDepth = 0;
    this._div1LoadingInst = null;
  },
  beforeUnmount() {
    if (this._div1LoadingInst) {
      this._div1LoadingInst.close();
      this._div1LoadingInst = null;
    }
    this._div1LoadingDepth = 0;
  },
  async mounted() {
    console.log("\nfinancialDashboard mounted start");
    const mountT0 = performance.now();
    let stepT0 = mountT0;
    const logStep = label => {
      const t = performance.now();
      const dt = t - stepT0;
      if (dt > SLOW_STEP_LOG_MS) {
        console.log(`[financialDashboard mounted] ${label}: ${dt.toFixed(1)}ms (>${SLOW_STEP_LOG_MS}ms)`);
      }
      stepT0 = t;
    };

    /** @param {{ alwaysLog?: boolean }} [options] alwaysLog 为 true 时无论快慢都打印（用于单独观测接口） */
    const runTimed = async (label, fn, options = {}) => {
      const t0 = performance.now();
      await fn();
      const ms = performance.now() - t0;
      if (options.alwaysLog) {
        console.log(`[financialDashboard mounted] ${label} 用时: ${ms.toFixed(1)}ms`);
      } else if (ms > SLOW_STEP_LOG_MS) {
        console.log(`[financialDashboard mounted] ${label} 用时: ${ms.toFixed(1)}ms (>${SLOW_STEP_LOG_MS}ms)`);
      }
      return ms;
    };

    // 年份可选前十年
    let currentYear = parseInt(moment().format("YYYY"));
    for (let i = currentYear; i >= currentYear - 10; i--) {
      this.years.push(i.toString());
    }
    logStep("初始化 years");

    // getConsultantPerformanceRankArray 依赖 consultantList，先拉顾问列表
    await runTimed("getConsultantList", () => this.getConsultantList());
    logStep("getConsultantList");
    await Promise.all([runTimed("getStudentNum", () => this.getStudentNum(), {
      alwaysLog: true
    }), runTimed("getConsumeInfo", () => this.getConsumeInfo(), {
      alwaysLog: true
    }), runTimed("getUnattendInfo", () => this.getUnattendInfo(), {
      alwaysLog: true
    }), (async () => {
      this.revenueSelectedYear = currentYear;
      this.revenueSelectedMonth = moment().format("YYYY-MM");
      await runTimed("营收查询 revenueSelected*Change", async () => {
        if (this.revenueSelect == "全年") {
          await this.revenueSelectedYearChange();
        }
        if (this.revenueSelect == "当月") {
          await this.revenueSelectedMonthChange();
        }
      }, {
        alwaysLog: true
      });
    })(), (async () => {
      this.consultantPerformanceSelectedYear = currentYear;
      this.consultantPerformanceSelectedMonth = moment().format("YYYY-MM");
      await runTimed("顾问业绩 consultantPerformanceSelected*Change", async () => {
        if (this.consultantPerformanceSelect == "全年") {
          await this.consultantPerformanceSelectedYearChange();
        }
        if (this.consultantPerformanceSelect == "当月") {
          await this.consultantPerformanceSelectedMonthChange();
        }
      }, {
        alwaysLog: true
      });
    })(), (async () => {
      this.sourceSelectedYear = currentYear;
      this.sourceSelectedMonth = moment().format("YYYY-MM");
      await runTimed("客户来源 sourceSelected*Change", async () => {
        if (this.sourceSelect == "全年") {
          await this.sourceSelectedYearChange();
        }
        if (this.sourceSelect == "当月") {
          await this.sourceSelectedMonthChange();
        }
      }, {
        alwaysLog: true
      });
    })()]);
    logStep("并行：getStudentNum / getConsumeInfo / getUnattendInfo + 营收 + 顾问业绩 + 客户来源");
    const dtMountAll = performance.now() - mountT0;
    if (dtMountAll > SLOW_STEP_LOG_MS) {
      console.log(`[financialDashboard mounted] 总用时: ${dtMountAll.toFixed(1)}ms (>${SLOW_STEP_LOG_MS}ms)`);
    }
    console.log("financialDashboard mounted end");
  },
  methods: {
    normalizeNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    },
    normalizeNumberList(value) {
      return Array.isArray(value) ? value.map(this.normalizeNumber) : [];
    },
    getSourceStatisticsList(value) {
      if (!value || typeof value !== "object") {
        return [];
      }
      return Object.entries(value).map(([source, count]) => ({
        source,
        count: this.normalizeNumber(count)
      })).sort((sourceStatisticA, sourceStatisticB) => {
        const countDiff = sourceStatisticB.count - sourceStatisticA.count;
        if (countDiff !== 0) {
          return countDiff;
        }
        return sourceStatisticA.source.localeCompare(sourceStatisticB.source, "zh-Hans-CN");
      });
    },
    formatAmount(value) {
      return this.normalizeNumber(value).toLocaleString();
    },
    /** #div1 区域 loading 引用计数，并行时 close 互不提前关掉整页遮罩 */
    acquireDiv1Loading(options = {}) {
      if (this._div1LoadingDepth === 0) {
        this._div1LoadingInst = this.$loadingDiv1({
          text: "处理中...",
          background: "rgba(0, 0, 0, 0.7)",
          ...options
        });
      }
      this._div1LoadingDepth++;
    },
    releaseDiv1Loading() {
      this._div1LoadingDepth = Math.max(0, this._div1LoadingDepth - 1);
      if (this._div1LoadingDepth === 0 && this._div1LoadingInst) {
        this._div1LoadingInst.close();
        this._div1LoadingInst = null;
      }
    },
    // 获取在读学员，结课学员人数
    async getStudentNum() {
      this.acquireDiv1Loading();
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/financialDashboard/getActiveStudentNum", params);
        if (resp1.data.code == "0000") {
          this.ongoingStudentNum = resp1.data.data.ongoingStudentNum;
          this.finishedStudentNum = resp1.data.data.finishedStudentNum;
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.releaseDiv1Loading();
      }
    },
    // 获取当月已消课时，当月已消金额
    async getConsumeInfo() {
      this.consumeInfoLoading = true;
      try {
        let startDate = moment().startOf("month").format("YYYY-MM-DD");
        let startTime = startDate + " 00:00:00";
        let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
        let dateTimeRange = [startTime, currentTime];
        let params = {
          institution: this.institution,
          dateTimeRange: dateTimeRange
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/financialDashboard/getConsumeInfo", params);
        if (resp1.data.code == "0000") {
          const data = resp1.data.data || {};
          this.attendedHours = this.normalizeNumber(data.attendedHours);
          this.attendedFee = this.normalizeNumber(data.attendedFee);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.consumeInfoLoading = false;
      }
    },
    // 获取未消课时，未消课时金额
    async getUnattendInfo() {
      this.unattendInfoLoading = true;
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/financialDashboard/getUnattendInfo", params);
        if (resp1.data.code == "0000") {
          const data = resp1.data.data || {};
          this.unattendedHours = this.normalizeNumber(data.unattendedHours);
          this.unattendedFee = this.normalizeNumber(data.unattendedFee);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.unattendInfoLoading = false;
      }
    },
    // 获取顾问列表
    async getConsultantList() {
      this.acquireDiv1Loading();
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/getSalesPerson", params);
        if (resp1.data.code == "0000") {
          this.consultantList = resp1.data.data;
          this.consultantNames = {};
          for (let i = 0; i < this.consultantList.length; i++) {
            this.consultantNames[this.consultantList[i].id] = this.consultantList[i].name;
          }

          // performanceTarget json化
          for (let i = 0; i < this.consultantList.length; i++) {
            if (this.consultantList[i].performanceTarget) {
              this.consultantList[i].performanceTarget = JSON.parse(this.consultantList[i].performanceTarget);
            } else {
              this.consultantList[i].performanceTarget = {};
            }
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.releaseDiv1Loading();
      }
    },
    // 获取顾问业绩
    async getConsultantPerformance() {
      this.acquireDiv1Loading();
      try {
        // 有些顾问，没有全部时间的日期范围
        if (!this.consultantDateRange || !this.consultantDateRange[0]) {
          this.consultantDateRange = [];
          this.consultantDateRange[0] = moment().format("YYYY-MM-DD");
          this.consultantDateRange[1] = moment().format("YYYY-MM-DD");
        }
        let params = {
          institution: this.institution,
          dateRange: this.consultantDateRange
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/consultantPerformance/getConsultantPerformanceSummary", params);
        if (resp1.data.code == "0000") {
          // console.log("顾问业绩resp1.data.data:", resp1.data.data);

          if (resp1.data.data.consultantPerformance) {
            this.consultantPerformance = resp1.data.data.consultantPerformance;
            this.consultantRealPayTotal = resp1.data.data.consultantRealPayTotal || {};
            this.consultantRefundTotal = resp1.data.data.consultantRefundTotal || {};
            this.consultantPerformanceRank = {};
            for (let i in this.consultantList) {
              let consultantId = this.consultantList[i].id;
              if (!this.consultantPerformance[consultantId]) {
                this.consultantPerformance[consultantId] = 0;
              }
              this.consultantPerformanceRank[consultantId] = 1;
              for (let consultantId_2 in this.consultantPerformance) {
                // 每有一个顾问比自己业绩高，排名变大1
                if (this.consultantPerformance[consultantId] < this.consultantPerformance[consultantId_2]) {
                  this.consultantPerformanceRank[consultantId] += 1;
                }
              }
            }
            return;
          }

          // 全部时间业绩
          if (this.selectAllTime) {
            this.allTimePerformance = resp1.data.data;

            ///////////////////
            // 交易记录
            this.allTimePerformance.consultantRealPayTotal = {};
            this.allTimePerformance.consultantPayTotal = {};
            for (let consultantId in this.allTimePerformance.consultantPay) {
              let total = 0;
              for (let i in this.allTimePerformance.consultantPay[consultantId]) {
                total += this.allTimePerformance.consultantPay[consultantId][i].amount;
              }
              this.allTimePerformance.consultantPayTotal[consultantId] = total;
              total = 0;
              for (let i in this.allTimePerformance.consultantPay[consultantId]) {
                // 如果有 real_prepay 字段，则用 real_prepay 计算总额
                if (this.allTimePerformance.consultantPay[consultantId][i].real_prepay) {
                  total += this.allTimePerformance.consultantPay[consultantId][i].real_prepay;
                }
                // 否则用 amount 计算总额
                else {
                  total += this.allTimePerformance.consultantPay[consultantId][i].amount;
                }
              }
              this.allTimePerformance.consultantRealPayTotal[consultantId] = total;
            }

            ///////////////////
            // 退费记录

            ///////////////////
            // 已消记录
            this.allTimePerformance.consultantAttendFeeTotal = {};
            for (let consultantId in this.allTimePerformance.consultantAttendFee) {
              let total = 0;
              for (let i in this.allTimePerformance.consultantAttendFee[consultantId]) {
                total += this.allTimePerformance.consultantAttendFee[consultantId][i].amount;
              }
              this.allTimePerformance.consultantAttendFeeTotal[consultantId] = total;
            }

            ///////////////////
            // 未消记录
            this.allTimePerformance.consultantUnattendFeeTotal = {};
            for (let consultantId in this.allTimePerformance.consultantUnattendFee) {
              let total = 0;
              for (let i in this.allTimePerformance.consultantUnattendFee[consultantId]) {
                total += this.allTimePerformance.consultantUnattendFee[consultantId][i].amount;
              }

              // 未消金额合计，还要加余额剩余
              if (this.allTimePerformance.consultantBalance[consultantId]) {
                for (let studentId in this.allTimePerformance.consultantBalance[consultantId]) {
                  total += this.allTimePerformance.consultantBalance[consultantId][studentId];
                }
              }
              this.allTimePerformance.consultantUnattendFeeTotal[consultantId] = total;
            }
          }
          // 非全部时间, 指定日期范围
          else {
            ///////////////////
            // 交易记录
            this.consultantPay = resp1.data.data.consultantPay;
            this.consultantRealPayTotal = {};
            this.consultantPayTotal = {};
            for (let consultantId in this.consultantPay) {
              let total = 0;
              for (let i in this.consultantPay[consultantId]) {
                total += this.consultantPay[consultantId][i].amount;
              }
              this.consultantPayTotal[consultantId] = total;
              total = 0;
              for (let i in this.consultantPay[consultantId]) {
                // 如果有 real_prepay 字段，则用 real_prepay 计算总额
                if (this.consultantPay[consultantId][i].real_prepay) {
                  total += this.consultantPay[consultantId][i].real_prepay;
                }
                // 否则用 amount 计算总额
                else {
                  total += this.consultantPay[consultantId][i].amount;
                }
              }
              this.consultantRealPayTotal[consultantId] = total;
            }

            ///////////////////
            // 退费记录
            this.consultantRefund = resp1.data.data.consultantRefund;
            this.consultantRefundTotal = {};
            this.consultantRefundServiceFeeTotal = {};
            this.consultantRefundRealTotal = {};
            for (let consultantId in this.consultantRefund) {
              if (!this.consultantRefundTotal[consultantId]) {
                this.consultantRefundTotal[consultantId] = 0;
              }
              if (!this.consultantRefundServiceFeeTotal[consultantId]) {
                this.consultantRefundServiceFeeTotal[consultantId] = 0;
              }
              if (!this.consultantRefundRealTotal[consultantId]) {
                this.consultantRefundRealTotal[consultantId] = 0;
              }
              for (let i in this.consultantRefund[consultantId]) {
                this.consultantRefundTotal[consultantId] += this.consultantRefund[consultantId][i].refundFee;
                this.consultantRefundServiceFeeTotal[consultantId] += this.consultantRefund[consultantId][i].refundServiceFee;
                this.consultantRefundRealTotal[consultantId] += this.consultantRefund[consultantId][i].refundRealFee;
              }
            }
            // console.log(
            //   "this.consultantRefundTotal:",
            //   this.consultantRefundTotal
            // );

            // 顾问业绩 = 实际缴费 - 退费
            for (let i in this.consultantList) {
              let consultantId = this.consultantList[i].id;
              if (!this.consultantRealPayTotal[consultantId]) {
                this.consultantRealPayTotal[consultantId] = 0;
              }
              if (!this.consultantRefundTotal[consultantId]) {
                this.consultantRefundTotal[consultantId] = 0;
              }
              this.consultantPerformance[consultantId] = this.consultantRealPayTotal[consultantId] - this.consultantRefundTotal[consultantId];
            }

            // 顾问业绩排名
            this.consultantPerformanceRank = {};
            for (let i in this.consultantList) {
              let consultantId = this.consultantList[i].id;

              // 如果顾问没业绩，赋值0
              if (!this.consultantPerformance[consultantId]) {
                this.consultantPerformance[consultantId] = 0;
              }
              this.consultantPerformanceRank[consultantId] = 1;
              for (let consultantId_2 in this.consultantPerformance) {
                // 每有一个顾问比自己业绩高，排名变大1
                if (this.consultantPerformance[consultantId] < this.consultantPerformance[consultantId_2]) {
                  this.consultantPerformanceRank[consultantId] += 1;
                }
              }
            }

            ///////////////////
            // 已消金额
            this.consultantAttendFee = resp1.data.data.consultantAttendFee;
            this.consultantAttendFeeTotal = {};
            for (let consultantId in this.consultantAttendFee) {
              let total = 0;
              for (let i in this.consultantAttendFee[consultantId]) {
                total += this.consultantAttendFee[consultantId][i].amount;
              }
              this.consultantAttendFeeTotal[consultantId] = total;
            }
            this.consultantBalance = resp1.data.data.consultantBalance;

            ///////////////////
            // 未消金额
            this.consultantUnattendFee = resp1.data.data.consultantUnattendFee;
            this.consultantUnattendFeeTotal = {};
            for (let consultantId in this.consultantUnattendFee) {
              let total = 0;
              for (let i in this.consultantUnattendFee[consultantId]) {
                total += this.consultantUnattendFee[consultantId][i].amount;
              }
              if (this.consultantBalance[consultantId]) {
                for (let studentId in this.consultantBalance[consultantId]) {
                  total += this.consultantBalance[consultantId][studentId];
                }
              }
              this.consultantUnattendFeeTotal[consultantId] = total;
            }
            this.consultantAttendFeeSummary = resp1.data.data.consultantAttendFeeSummary;
            this.consultantUnattendFeeSummary = resp1.data.data.consultantUnattendFeeSummary;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.releaseDiv1Loading();
      }
    },
    // 计算顾问业绩排名数组
    getConsultantPerformanceRankArray() {
      //
      this.consultantPerformanceRankArray = [];
      for (let i in this.consultantList) {
        let consultantId = this.consultantList[i].id;
        let consultantIndex = this.consultantList.findIndex(item => item.id === consultantId);
        let target = 0;
        if (this.consultantPerformanceSelect == "全年") {
          // 每个月
          for (let i = 1; i <= 12; i++) {
            // 如果指标不存在，设为0
            if (!this.consultantList[consultantIndex].performanceTarget[this.consultantPerformanceSelectedYear + "-" + i.toString().padStart(2, "0")]) {
              this.consultantList[consultantIndex].performanceTarget[this.consultantPerformanceSelectedYear + "-" + i.toString().padStart(2, "0")] = 0;
            }
            target += parseInt(this.consultantList[consultantIndex].performanceTarget[this.consultantPerformanceSelectedYear + "-" + i.toString().padStart(2, "0")]);
          }
        }
        if (this.consultantPerformanceSelect == "当月") {
          // 如果指标不存在，设为0
          if (!this.consultantList[consultantIndex].performanceTarget[this.consultantPerformanceSelectedMonth]) {
            this.consultantList[consultantIndex].performanceTarget[this.consultantPerformanceSelectedMonth] = 0;
          }
          target = parseInt(this.consultantList[consultantIndex].performanceTarget[this.consultantPerformanceSelectedMonth]);
        }

        // 初始空直接push
        if (this.consultantPerformanceRankArray.length == 0) {
          this.consultantPerformanceRankArray.push({
            consultantId: consultantId,
            amount: this.consultantPerformance[consultantId],
            target: target
          });
          continue;
        }
        for (let j in this.consultantPerformanceRankArray) {
          // 如果这个顾问业绩比数组的顾问业绩高，插入数组前面
          if (this.consultantPerformance[consultantId] > this.consultantPerformanceRankArray[j].amount) {
            // array.splice(index, 0, item);
            // index: 插入元素的位置（索引）。
            // 0: 表示不删除任何元素。
            // item: 要插入的元素。
            this.consultantPerformanceRankArray.splice(j, 0, {
              consultantId: consultantId,
              amount: this.consultantPerformance[consultantId],
              target: target
            });
            break;
          }
          //
          else {
            // 如果是最后一个，则插入数组后面
            if (j == this.consultantPerformanceRankArray.length - 1) {
              this.consultantPerformanceRankArray.push({
                consultantId: consultantId,
                amount: this.consultantPerformance[consultantId],
                target: target
              });
            }
          }
        }
      }
    },
    // 获取客户来源渠道统计
    async getSourceStatistics() {
      this.acquireDiv1Loading();
      try {
        let params = {
          institution: this.institution,
          dateRange: this.sourceDateRange
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/financialDashboard/getSourceStatistics", params);
        if (resp1.data.code == "0000") {
          this.sourceStatistics = resp1.data.data || {};
          this.sourceStatisticsList = this.getSourceStatisticsList(this.sourceStatistics);

          // console.log("this.sourceStatisticsList:", this.sourceStatisticsList);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.releaseDiv1Loading();
      }
    },
    // 客户来源 柱状图
    async drawChart1() {
      // 等待 DOM 更新
      await this.$nextTick();
      var chartDom = this.$refs.sourceChartRef;
      if (!chartDom) {
        return;
      }
      var myChart = echarts.init(chartDom);
      var option;
      let xData = [];
      let yData = [];
      let i = 0;
      let chartColors = [];
      this.sourceColor = {};
      for (let sourceStatistic of this.sourceStatisticsList) {
        xData.push(sourceStatistic.source);

        // 每个柱子不同颜色
        yData.push({
          value: sourceStatistic.count,
          itemStyle: {
            color: this.colorOptions[i % 5]
          }
        });
        // yData.push(this.sourceStatistics[source])

        this.sourceColor[sourceStatistic.source] = this.colorOptions[i % 5];

        // chartColors.push(this.colorOptions[i%5]);

        i++;
      }
      // console.log("chartColors:", chartColors);

      option = {
        // color: chartColors, // 使用预定义的颜色数组
        grid: {
          left: "3%",
          right: "0%",
          bottom: "3%",
          top: "5%"
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            show: false // 隐藏 x 轴文字标签
          }
        },
        yAxis: {
          type: "value",
          minInterval: 1 // 强制 y 轴刻度最小间隔为 1（即整数）在y值几十时，也不会刻度太密
        },
        series: [{
          data: yData,
          type: "bar",
          barMaxWidth: 10 // 设置柱子最大宽度为 50 像素
        }]
      };
      option && myChart.setOption(option);
    },
    async drawChart2() {
      // 等待 DOM 更新
      await this.$nextTick();
      var chartDom = this.$refs.revenueChartRef;
      if (!chartDom) {
        return;
      }
      var myChart = echarts.init(chartDom);
      var option;
      let data = [];
      let dates = [];
      if (this.revenueSelect == "全年") {
        data = this.monthlyRevenue;
      } else {
        data = this.dailyRevenue;
      }
      dates = Array.from({
        length: data.length
      }, (_, index) => index + 1);
      option = {
        tooltip: {
          trigger: "axis",
          formatter: params => {
            let date = "";
            if (this.revenueSelect == "全年") {
              date = this.revenueSelectedYear + "-" + params[0].name.toString().padStart(2, "0");
            } else {
              date = this.revenueSelectedMonth + "-" + params[0].name.toString().padStart(2, "0");
            }
            const value = this.formatAmount(params[0].value);

            // 只加粗金额，突出显示
            return `${date}<br/> <strong style="color: black;">￥${value}</strong>`;
          }
        },
        grid: {
          top: "4%",
          left: "3%",
          right: "4%",
          bottom: "2%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: dates,
          axisLabel: {
            rotate: 0,
            interval: "auto" // 自动避免重叠
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}"
          }
        },
        series: [{
          name: "金额",
          type: "line",
          smooth: true,
          data: data,
          itemStyle: {
            color: "#409EFF"
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: "rgba(64, 158, 255, 0.5)"
            }, {
              offset: 1,
              color: "rgba(64, 158, 255, 0.05)"
            }])
          }
        }]
        // 关键：启用数据区域缩放（即拖动查看）
        // dataZoom: [
        //   {
        //     type: "inside", // 内部拖动
        //     start: 0, // 初始显示前7天
        //     end: 20, // 初始显示到第20天左右
        //   },
        //   {
        //     type: "slider", // 底部滑块
        //     start: 0,
        //     end: 20,
        //   },
        // ],
      };
      myChart.setOption(option);
    },
    // 营收查询 切换 全年/当月
    async revenueSelectChange() {
      if (this.revenueSelect == "全年") {
        await this.revenueSelectedYearChange();
      }
      if (this.revenueSelect == "当月") {
        await this.revenueSelectedMonthChange();
      }
    },
    // 营收查询 选择年份
    async revenueSelectedYearChange() {
      this.acquireDiv1Loading();
      try {
        let params = {
          institution: this.institution,
          year: this.revenueSelectedYear
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/financialDashboard/getMonthlyRevenue", params);
        if (resp1.data.code == "0000") {
          this.monthlyRevenue = this.normalizeNumberList(resp1.data.data);
          console.log("this.monthlyRevenue:", this.monthlyRevenue);
          this.yearRevenue = 0;
          for (let i in this.monthlyRevenue) {
            this.yearRevenue += this.monthlyRevenue[i];
          }

          // 获取上一年的营收
          await this.getPreviousYearRevenue();
          await this.drawChart2();
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.releaseDiv1Loading();
      }
    },
    // 营收查询 选择月份
    async revenueSelectedMonthChange() {
      this.acquireDiv1Loading();
      try {
        let params = {
          institution: this.institution,
          yearMonth: this.revenueSelectedMonth
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/financialDashboard/getDailyRevenue", params);
        if (resp1.data.code == "0000") {
          this.dailyRevenue = this.normalizeNumberList(resp1.data.data);

          // console.log("this.dailyRevenue:", this.dailyRevenue);

          this.monthRevenue = 0;
          for (let i in this.dailyRevenue) {
            this.monthRevenue += this.dailyRevenue[i];
          }
          await this.getPreviousMonthRevenue();
          await this.drawChart2();
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.releaseDiv1Loading();
      }
    },
    // 点击div展开选择年份
    revenueSelectYear() {
      if (this.revenueSelect != "全年") {
        this.revenueSelect = "全年";
      }

      // 通过 ref 获取 el-select 实例
      const select = this.$refs.revenueYearSelectRef;
      if (select) {
        // 调用 toggleMenu 方法展开下拉菜单
        select.toggleMenu();
      }
    },
    // 点击div展开选择月份
    revenueSelectMonth() {
      if (this.revenueSelect != "当月") {
        this.revenueSelect = "当月";
      }

      // 通过 ref 获取 el-date-picker 实例
      const datePicker = this.$refs.revenueMonthDatePickerRef;
      // console.log("datePicker:", datePicker);
      if (datePicker) {
        // 调用 focus 方法展开日期选择器
        datePicker.focus();
      }
    },
    // 获取 选择的年份 上一年 的总营收
    async getPreviousYearRevenue() {
      this.acquireDiv1Loading();
      try {
        let previousYear = moment(this.revenueSelectedYear, "YYYY").subtract(1, "year").format("YYYY");
        let params = {
          institution: this.institution,
          year: previousYear
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/financialDashboard/getMonthlyRevenue", params);
        if (resp1.data.code == "0000") {
          let monthlyRevenue = this.normalizeNumberList(resp1.data.data);
          this.previousYearRevenue = 0;
          for (let i in monthlyRevenue) {
            this.previousYearRevenue += monthlyRevenue[i];
          }
          console.log("this.previousYearRevenue:", this.previousYearRevenue);
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.releaseDiv1Loading();
      }
    },
    // 获取 选择的月份 上个月 的总营收
    async getPreviousMonthRevenue() {
      this.acquireDiv1Loading();
      try {
        const previousYearMonth = moment(this.revenueSelectedMonth, "YYYY-MM").subtract(1, "month").format("YYYY-MM");
        let params = {
          institution: this.institution,
          yearMonth: previousYearMonth
        };
        let resp1 = await axios.post("https://backend.wonology.com/finance/financialDashboard/getDailyRevenue", params);
        if (resp1.data.code == "0000") {
          let dailyRevenue = this.normalizeNumberList(resp1.data.data);
          this.previousMonthRevenue = 0;
          for (let i in dailyRevenue) {
            this.previousMonthRevenue += dailyRevenue[i];
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        this.releaseDiv1Loading();
      }
    },
    // 顾问业绩 切换 全年/当月
    async consultantPerformanceSelectChange() {
      if (this.consultantPerformanceSelect == "全年") {
        await this.consultantPerformanceSelectedYearChange();
      }
      if (this.consultantPerformanceSelect == "当月") {
        await this.consultantPerformanceSelectedMonthChange();
      }
    },
    // 顾问业绩 选择年份
    async consultantPerformanceSelectedYearChange() {
      this.consultantDateRange = [this.consultantPerformanceSelectedYear + "-01-01", this.consultantPerformanceSelectedYear + "-12-31"];

      // 获取顾问业绩
      await this.getConsultantPerformance();
      // 计算顾问业绩排名
      this.getConsultantPerformanceRankArray();
    },
    // 顾问业绩 选择月份
    async consultantPerformanceSelectedMonthChange() {
      let startDate = moment(this.consultantPerformanceSelectedMonth, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
      let endDate = moment(this.consultantPerformanceSelectedMonth, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
      this.consultantDateRange = [startDate, endDate];

      // 获取顾问业绩
      await this.getConsultantPerformance();
      // 计算顾问业绩排名
      this.getConsultantPerformanceRankArray();
    },
    // 点击div展开选择年份
    consultantPerformanceSelectYear() {
      if (this.consultantPerformanceSelect != "全年") {
        this.consultantPerformanceSelect = "全年";
      }

      // 通过 ref 获取 el-select 实例
      const select = this.$refs.yearSelectRef;
      if (select) {
        // 调用 toggleMenu 方法展开下拉菜单
        select.toggleMenu();
      }
    },
    // 点击div展开选择月份
    consultantPerformanceSelectMonth() {
      if (this.consultantPerformanceSelect != "当月") {
        this.consultantPerformanceSelect = "当月";
      }

      // 通过 ref 获取 el-date-picker 实例
      const datePicker = this.$refs.monthDatePickerRef;
      // console.log("datePicker:", datePicker);
      if (datePicker) {
        // 调用 focus 方法展开日期选择器
        datePicker.focus();
      }
    },
    // 客户来源 切换 全年/当月
    async sourceSelectChange() {
      if (this.sourceSelect == "全年") {
        await this.sourceSelectedYearChange();
      }
      if (this.sourceSelect == "当月") {
        await this.sourceSelectedMonthChange();
      }
    },
    // 客户来源 选择年份
    async sourceSelectedYearChange() {
      this.sourceDateRange = [this.sourceSelectedYear + "-01-01", this.sourceSelectedYear + "-12-31"];

      // 获取客户来源渠道统计
      await this.getSourceStatistics();

      // 有新学生，才画图
      if (this.sourceStatisticsList.length > 0) {
        await this.drawChart1();
      }
    },
    // 客户来源 选择月份
    async sourceSelectedMonthChange() {
      let startDate = moment(this.sourceSelectedMonth, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
      let endDate = moment(this.sourceSelectedMonth, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
      this.sourceDateRange = [startDate, endDate];

      // 获取客户来源渠道统计
      await this.getSourceStatistics();

      // 有新学生，才画图
      if (this.sourceStatisticsList.length > 0) {
        await this.drawChart1();
      }
    },
    // 点击div展开选择年份
    sourceSelectYear() {
      if (this.sourceSelect != "全年") {
        this.sourceSelect = "全年";
      }

      // 通过 ref 获取 el-select 实例
      const select = this.$refs.sourceYearSelectRef;
      if (select) {
        // 调用 toggleMenu 方法展开下拉菜单
        select.toggleMenu();
      }
    },
    // 点击div展开选择月份
    sourceSelectMonth() {
      if (this.sourceSelect != "当月") {
        this.sourceSelect = "当月";
      }

      // 通过 ref 获取 el-date-picker 实例
      const datePicker = this.$refs.sourceMonthDatePickerRef;
      // console.log("datePicker:", datePicker);
      if (datePicker) {
        // 调用 focus 方法展开日期选择器
        datePicker.focus();
      }
    }
  }
};